import { groupBy } from '@eversports/lists'
import { format } from '@eversports/dates'

import { EventBookableItem } from '../components/ActivityCard/ActivityCard.types'

export default function groupActivitiesByDate(activities: Array<EventBookableItem>) {
  // Group the activities by date
  // We want to show the user activities in sections, each section being a date.
  const activitiesGroupedByDate = groupBy<string, EventBookableItem>(activities, (activity) => {
    const startDate = activity?.eventSessions?.[0]?.start
    const parsedDate = new Date(startDate)
    return format(parsedDate, 'yyyy-MM-dd')
  })

  // Convert with activitiesGroupedByDate into an array that can be mapped over for rendered the results in JSX
  const groupingsAsArray = Array.from(activitiesGroupedByDate.entries()).map(([groupDate, activities]) => ({
    groupDate,
    activities,
  }))

  return groupingsAsArray
}
